/**
 * Acesso às rotas de API do backend (Next.js) a partir do widget.
 *
 * O widget pode rodar via CDN em qualquer domínio; as rotas ficam no backend
 * em `API_BASE_URL`. Para testes locais defina `window.__CALLIX_API_BASE_URL__`
 * ANTES de carregar o bundle do widget (ex.: `window.location.origin`).
 */

export const DEFAULT_API_BASE_URL = 'https://callix-zeta.vercel.app';

export function resolveApiBaseUrl(): string {
  if (typeof window === 'undefined') {
    return DEFAULT_API_BASE_URL;
  }
  const override = (window as unknown as Record<string, unknown>).__CALLIX_API_BASE_URL__;
  if (typeof override === 'string' && override.trim()) {
    return override.trim().replace(/\/+$/, '');
  }
  return DEFAULT_API_BASE_URL;
}

export const API_BASE_URL = resolveApiBaseUrl();

export const LAST_USERNAME_STORAGE_KEY = 'callix_dialer_last_username';

/**
 * Token da sessão do SDK salvo pelo widget no localStorage
 * (padrão `callix_dialer_{username}_session_token`).
 */
export function getSessionToken(): string | null {
  if (typeof window === 'undefined') {
    return null;
  }
  try {
    const lastUsername = localStorage.getItem(LAST_USERNAME_STORAGE_KEY);
    if (lastUsername) {
      const token = localStorage.getItem(`callix_dialer_${lastUsername}_session_token`);
      if (token) {
        return token;
      }
    }
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && /^callix_dialer_.*_session_token$/.test(key)) {
        const token = localStorage.getItem(key);
        if (token) {
          return token;
        }
      }
    }
  } catch {
    // localStorage indisponível (modo privado, iframe bloqueado...)
  }
  return null;
}

/** Headers de autenticação aceitos pelas rotas de API (Authorization + x-session-token). */
export function getAuthHeaders(): Record<string, string> {
  const headers: Record<string, string> = { 'Content-Type': 'application/json' };
  const token = getSessionToken();
  if (token) {
    headers['x-session-token'] = token;
    headers['Authorization'] = `Bearer ${token}`;
  }
  return headers;
}
